module.exports = (__parcel__import__("kGNJT")).then(() => parcelRequire('g36Vt'));